import { COPIES } from '../components/constants';
import { DEPARTMENT_KEYS } from '../shared/comeet/comeet_api/constants';

export const getTeams = () =>
    Object.keys(DEPARTMENT_KEYS).map((department) => ({
        link: DEPARTMENT_KEYS[department],
        title: COPIES.teams[DEPARTMENT_KEYS[department]],
    }));
